export default __webpack_public_path__ + "static/media/AGC_Question_Paper_Class_1.dc7458c5.pdf";